import * as React from "react";
import { Group } from "./types";

export interface GroupContextInterface {
    groups: Group[];
}

export const GroupContext = React.createContext<GroupContextInterface | null>(null);